import { Col, Row } from 'antd';
import Header from 'components/Program/Header';
import Description from 'components/Program/Description';
import { useProgramViewModel } from 'components/Program/program.viewModel';
import React, { FC, useEffect, useState } from 'react';
import useGetProgramQuery from 'apollo/resolvers/programs/get';
import LoadingModal from 'components/generalUI/LoadingModal';
import { Program as ProgramType } from 'apollo/types';

const AULA_TRICAO_PROGRAM_ID = '1';
const AULA_TRICAO_QUOTE_URL = 'https://www.aulatricao.cl/solicitud';

const TricaoClassroom: FC = () => {
  const { setProgramFromQuery } = useProgramViewModel();
  const { data, loading } = useGetProgramQuery(AULA_TRICAO_PROGRAM_ID);

  const [program, setProgram] = useState<ProgramType>();

  useEffect(() => {
    setProgramFromQuery(data, setProgram);
  }, [data]);

  return (
    <Row>
      <Col span={24}>
        <LoadingModal visible={loading} />
        {program && (
          <>
            <Header
              title={program.title}
              subtitle={program.subtitle}
              coverImage={program.coverImage?.url || ''}
              quoteHref={AULA_TRICAO_QUOTE_URL}
              quoteExternal
            />
            <Description
              title={program.title}
              description={program.description}
              duration={program.hoursDuration}
              targetGroup={program.targetGroup}
              programPictureUrls={
                program.secondaryImages?.map((image) => image.url) || []
              }
            />
          </>
        )}
      </Col>
    </Row>
  );
};

export default TricaoClassroom;
